"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixTextInText = fixTextInText;
const tex_syntax_1 = require("./tex-syntax");
const textWithBlockArg = new RegExp(`\\\\\\\\|\\\\text(${(0, tex_syntax_1.block)(3)})`, "g");
function fixTextInText(tex) {
    return tex.replace(
    // Find all occurrences of \text followed by a block...
    textWithBlockArg, (match, _block) => {
        // ignore linebreaks (\\) followed by the word "text". Only process
        // actual text commands.
        if (!match.startsWith("\\text")) {
            return match;
        }
        // Fix up the contents of the block by removing occurrences of
        // \text. Ignore any that are inside $...$ (which goes back into
        // math mode, so \text is allowed).
        return `\\text${_block.replace(/\\\\|\\\$|\$(\\\$|[^$])*\$|(\\text\s*)/g, (match) => (match.startsWith("\\text") ? "" : match))}`;
    });
}
